"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var entities_1 = require("../entities");
/**
 * Procedure that assigns a Security Token Role to a delegate address.
 * Roles grant said delegate permissions over certain Security Token Features
 */


var AssignSecurityTokenRole =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(AssignSecurityTokenRole, _Procedure_1$Procedur);

  function AssignSecurityTokenRole() {
    var _this;

    _classCallCheck(this, AssignSecurityTokenRole);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AssignSecurityTokenRole).apply(this, arguments));
    _this.type = types_1.ProcedureType.AssignSecurityTokenRole;
    return _this;
  }
  /**
   * - If the delegate does not exist, the delegate address will be added
   * - The specified Role will be assigned/revoked to/from the delegate
   *
   * Note this procedure will fail if:
   * - You attempt to assign a Role related to a Feature that hasn't been enabled
   * - The Permissions Feature hasn't been enabled on the Security Token
   * - You attempt to assign/revoke a Role that has already been assigned/revoked
   */


  _createClass(AssignSecurityTokenRole, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this$args, symbol, role, assign, description, delegateAddress, contractWrappers, delegate, permissionModule, _ref, _ref$permissions, isRoleAvailable, getFeatureFromRole, _ref2, _ref3, isAvailable, requiredFeature, _ref4, moduleName, perm, moduleAddress, delegates, exists, permittedDelegates, permitted;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$args = this.args, symbol = _this$args.symbol, role = _this$args.role, assign = _this$args.assign, description = _this$args.description, delegateAddress = _this$args.delegateAddress;
                contractWrappers = this.context.contractWrappers;
                delegate = contract_wrappers_1.conversionUtils.checksumAddress(delegateAddress);
                _context.prev = 3;
                _context.next = 6;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](3);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 11:
                _context.next = 13;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.GeneralPermissionManager,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 13:
                permissionModule = _context.sent[0];

                if (permissionModule) {
                  _context.next = 16;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'You must enable the Permissions feature in order to assign roles'
                });

              case 16:
                _context.next = 18;
                return this.context.factories.securityTokenFactory.fetch(entities_1.SecurityToken.generateId({
                  symbol: symbol
                }));

              case 18:
                _ref = _context.sent;
                _ref$permissions = _ref.permissions;
                isRoleAvailable = _ref$permissions.isRoleAvailable;
                getFeatureFromRole = _ref$permissions.getFeatureFromRole;
                _context.next = 24;
                return Promise.all([isRoleAvailable({
                  role: role
                }), getFeatureFromRole({
                  role: role
                })]);

              case 24:
                _ref2 = _context.sent;
                _ref3 = _slicedToArray(_ref2, 2);
                isAvailable = _ref3[0];
                requiredFeature = _ref3[1];

                if (isAvailable) {
                  _context.next = 30;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FeatureNotEnabled,
                  message: "You must enable the ".concat(requiredFeature, " feature in order to assign the ").concat(role, " role")
                });

              case 30:
                _context.next = 32;
                return contractWrappers.roleToPermission({
                  role: role
                });

              case 32:
                _ref4 = _context.sent;
                moduleName = _ref4.moduleName;
                perm = _ref4.permission;
                _context.next = 37;
                return contractWrappers.getModuleAddressesByName({
                  moduleName: moduleName,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 37:
                moduleAddress = _context.sent[0];
                _context.next = 40;
                return permissionModule.getAllDelegates();

              case 40:
                delegates = _context.sent;
                exists = delegates.filter(function (element) {
                  return element.toUpperCase() === delegate.toUpperCase();
                }).length > 0;
                /*
                 * In the following block we attempt to:
                 * - Find whether the delegate address is already present. Otherwise add them
                 * - Find whether the current delegate permission is equal to the provided one. Otherwise change permissions
                 */

                if (!exists) {
                  _context.next = 51;
                  break;
                }

                _context.next = 45;
                return permissionModule.getAllDelegatesWithPerm({
                  module: moduleAddress,
                  perm: perm
                });

              case 45:
                permittedDelegates = _context.sent;
                permitted = !!permittedDelegates.find(function (element) {
                  return element.toUpperCase() === delegate.toUpperCase();
                }); // Upcoming permission equals existing one

                if (!(permitted === assign)) {
                  _context.next = 49;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "Role ".concat(role, " has already been ").concat(assign ? 'assigned to' : 'revoked from', " delegate.")
                });

              case 49:
                _context.next = 53;
                break;

              case 51:
                _context.next = 53;
                return this.addTransaction(permissionModule.addDelegate, {
                  tag: types_1.PolyTransactionTag.AddDelegate
                })({
                  delegate: delegate,
                  details: description
                });

              case 53:
                _context.next = 55;
                return this.addTransaction(permissionModule.changePermission, {
                  tag: types_1.PolyTransactionTag.ChangePermission
                })({
                  delegate: delegate,
                  module: moduleAddress,
                  perm: perm,
                  valid: assign
                });

              case 55:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 8]]);
      }));
    }
  }]);

  return AssignSecurityTokenRole;
}(Procedure_1.Procedure);

exports.AssignSecurityTokenRole = AssignSecurityTokenRole;